import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetCommittedOrderRequest extends BaseDataGridRequest {
    searchParam?: string;
  }